import { render, staticRenderFns } from "./UserBloc.vue?vue&type=template&id=434d38f8&scoped=true&"
import script from "./UserBloc.vue?vue&type=script&lang=js&"
export * from "./UserBloc.vue?vue&type=script&lang=js&"
import style0 from "./UserBloc.vue?vue&type=style&index=0&id=434d38f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "434d38f8",
  null
  
)

export default component.exports